import {
  text
} from "cignacmb-vue-components-mobile/src/popup-instances/toast.js";
// 处理请求成功时的数据
export default function (data) {
  // console.log("data",data);
  // debugger;
  if (data.statusCode == '200') {
    return data.data;
  } else if (data.statusCode == '204') {//活动已下架
    return Promise.reject(data);
  } else if(data.data==null) {  //判断如果接口没有返回值 就什么都不显示
    return
  } else {
    const error = new Error(data.msg);
    error.statusCode = data.statusCode;

    text.open({
      message: error.message
    });

    return Promise.reject(error);
  }
}